"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var apms_javascript_sdk_1 = require("@shopee/apms-javascript-sdk");
var log_1 = require("@shopee/apms-javascript-sdk/lib/utils/log");
var historyListner_1 = require("./historyListner");
var constants_1 = require("./constants");
var utils_1 = require("./utils");
var custom_1 = require("@shopee/apms-javascript-sdk/lib/plugin/custom");
var breadcrumb_1 = __importDefault(require("./breadcrumb"));
var ExceptionPlugin = /** @class */ (function (_super) {
    __extends(ExceptionPlugin, _super);
    function ExceptionPlugin(config) {
        var _this = _super.call(this, config) || this;
        _this.interval = constants_1.DEFAULT_CHECK_INTERVAL;
        _this.reportAtInterval = true;
        _this.breadcrumb = new breadcrumb_1.default();
        _this.type = 'exception';
        _this.delegateReporter = true;
        _this.reportDatas = [];
        if (typeof (config === null || config === void 0 ? void 0 : config.interval) === 'number') {
            _this.interval = config.interval;
        }
        if ((config === null || config === void 0 ? void 0 : config.mode) === 'history') {
            _this.reportAtInterval = false;
        }
        // this.reportAtInterval = config?.mode === 'interval';
        // 默认 interval 支持其他模式再说
        _this.path = config === null || config === void 0 ? void 0 : config.path;
        _this.beforeAddData = config === null || config === void 0 ? void 0 : config.beforeAddData;
        _this.transport = config === null || config === void 0 ? void 0 : config.transport;
        return _this;
    }
    ExceptionPlugin.trackError = function (event, error) {
        if (!Object.keys(ExceptionPlugin.TRIGGER_MAPS).length) {
            return;
        }
        try {
            var exception = error;
            if (!exception) {
                exception =
                    typeof event === 'string'
                        ? {
                            name: 'ErrorEvent',
                            message: event,
                        }
                        : {
                            name: event.type,
                            message: 'unknown',
                        };
            }
            var reportData = {
                // timestamp: this.serverNow(),
                js_error_type: 'error',
                js_error_level: 'error',
                js_error_name: exception.name,
                js_error_message: exception.message,
                js_error_stack: exception.stack,
                js_original_exception: (0, utils_1.stringifyOriginalException)(exception),
                js_page_name: window.location.hostname,
            };
            reportData.js_error_stack = (0, utils_1.preProcessStack)(reportData.js_error_stack);
            for (var _i = 0, _a = Object.values(ExceptionPlugin.TRIGGER_MAPS); _i < _a.length; _i++) {
                var listener = _a[_i];
                listener.triggerFunction(reportData);
            }
        }
        catch (error) {
            log_1.Logger.error(error);
        }
    };
    ExceptionPlugin.trackEvent = function (event) {
        var _a;
        if (!Object.keys(ExceptionPlugin.TRIGGER_MAPS).length) {
            return;
        }
        try {
            var stack = undefined;
            var errorMessage = typeof event.reason === 'string' ? event.reason : (_a = event.reason) === null || _a === void 0 ? void 0 : _a.message;
            var errorName = event.type;
            if (event.reason instanceof Error) {
                errorMessage = event.reason.message;
                errorName = event.reason.name;
                stack = event.reason.stack;
            }
            if (!stack && typeof Error.captureStackTrace === 'function') {
                if (errorMessage instanceof Object) {
                    errorMessage = JSON.stringify(errorMessage);
                }
                var exception = {
                    message: errorMessage,
                };
                Error.captureStackTrace(exception);
                stack = exception.stack;
            }
            var reportData = {
                // timestamp: this.serverNow(),
                js_error_type: 'unhandledrejection',
                js_error_level: 'error',
                js_error_name: errorName,
                js_error_message: errorMessage,
                js_error_stack: stack,
                js_original_exception: (0, utils_1.stringifyOriginalException)(event.reason),
                js_page_name: window.location.hostname,
            };
            reportData.js_error_stack = (0, utils_1.preProcessStack)(reportData.js_error_stack);
            for (var _i = 0, _b = Object.values(ExceptionPlugin.TRIGGER_MAPS); _i < _b.length; _i++) {
                var listener = _b[_i];
                listener.triggerFunction(reportData);
            }
        }
        catch (error) {
            log_1.Logger.error(error);
        }
    };
    ExceptionPlugin.prototype.isPageUrlMatch = function () {
        //
        if (!this.path) {
            return true;
        }
        var path = window.location.href;
        if ((0, utils_1.isMatchArray)(this.path)) {
            var matched = false;
            for (var _i = 0, _a = this.path; _i < _a.length; _i++) {
                var rule = _a[_i];
                if (path.match(rule)) {
                    matched = true;
                    break;
                }
            }
            return matched;
        }
        return !!path.match(this.path);
    };
    ExceptionPlugin.prototype.register = function (props) {
        var _this = this;
        this.de_app_id = props.de_app_id;
        // 初始化数据
        this.processData();
        var addData = function (data) {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
            try {
                if (!_this.isPageUrlMatch()) {
                    return;
                }
                if (((_a = _this.beforeAddData) === null || _a === void 0 ? void 0 : _a.call(_this, data)) === false) {
                    return;
                }
                if (!_this.reportDatas.length) {
                    _this.processData();
                }
                var reportData = _this.reportDatas[_this.reportDatas.length - 1];
                // if (reportData.labels?.entries_length) {
                //   // entries length already greather than limit, increase entries length and discard exception entry.
                //   reportData.labels.entries_length += 1;
                //   return;
                // }
                if (reportData.events.length >= constants_1.LIMITATIONS.REPORT_TRANSACTION_LIMIT) {
                    // Reach entries size limit, set labels and clean entries
                    // reportData.labels = Object.assign(reportData.labels ?? {}, {
                    //   entries_length: reportData.data.exceptions.length,
                    // });
                    // reportData.events = [reportData.events[0]];
                    // return;
                    _this.processData();
                    reportData = _this.reportDatas[_this.reportDatas.length - 1];
                }
                // Add exception entry data
                // if (this.reportAtInterval) {
                //   // fill report-page-url in data field
                //   data.data_field = Object.assign(data.data_field ?? {}, {
                //     report_page_url: `${window.location.href.slice(0, 512)}`,
                //   });
                // }
                // 用户在使用 this.beforeAddData 时也可能会直接修改 data
                if (typeof ((_b = _this.beforeAddData) === null || _b === void 0 ? void 0 : _b.call(_this, data)) === 'object') {
                    data = Object.assign(data, (_c = _this.beforeAddData) === null || _c === void 0 ? void 0 : _c.call(_this, data));
                }
                data.js_data_field = Object.assign((_d = data.js_data_field) !== null && _d !== void 0 ? _d : {}, {
                    report_page_url: "".concat(window.location.href.slice(0, 512)),
                });
                if (Object.keys((_f = (_e = _this.reporter) === null || _e === void 0 ? void 0 : _e.tags) !== null && _f !== void 0 ? _f : {}).length) {
                    data.js_data_field = Object.assign({}, (_h = (_g = _this.reporter) === null || _g === void 0 ? void 0 : _g.tags) !== null && _h !== void 0 ? _h : {}, (_j = data.js_data_field) !== null && _j !== void 0 ? _j : {});
                }
                data.js_data_field = Object.assign((_k = data.js_data_field) !== null && _k !== void 0 ? _k : {}, window.location.hash
                    ? {
                        path_hash: window.location.hash,
                    }
                    : {}, window.location.search
                    ? {
                        path_search: window.location.search,
                    }
                    : {});
                data.js_breadcrumbs = _this.breadcrumb.get();
                var event_1 = __assign(__assign({}, (_l = _this.reporter) === null || _l === void 0 ? void 0 : _l.commonData), { eventType: 'web_js_error', tag: 'web-exception', exceptions: [__assign({}, data)] });
                event_1.extra.webCommonData = Object.assign({}, event_1.extra.webCommonData, ((_m = _this.transport) === null || _m === void 0 ? void 0 : _m.call(_this, data)) || {});
                reportData.events.push(event_1);
            }
            catch (error) {
                log_1.Logger.warn('[APMS] Failed to add datas');
            }
        };
        this.triggerHandler = addData;
        ExceptionPlugin.TRIGGER_MAPS[props.de_app_id] = {
            triggerFunction: addData,
        };
        this.init(props.de_app_id);
    };
    // 预处理数据
    ExceptionPlugin.prototype.processData = function () {
        if (!this.reporter) {
            // error message
            return;
        }
        try {
            // do not create a new exception request data if there is already one with no events
            if (this.reportDatas.length &&
                !this.reportDatas[this.reportDatas.length - 1].events.length) {
                return;
            }
            var result = {
                apiKey: this.reporter.configs.secret_key,
                notifier: {},
                payloadVersion: '1.0',
                events: [],
            };
            this.reportDatas.push(result);
            return result;
        }
        catch (error) {
            log_1.Logger.info('[APMS] Failed to process exception data');
            log_1.Logger.error(error);
        }
    };
    ExceptionPlugin.prototype.getDataChunks = function () {
        // let entriesCount = 0;
        // let trimmedEventCount = 0;
        var chunks = [];
        var leftData = this.reportAtInterval ? 0 : 1;
        while (this.reportDatas.length > leftData) {
            var eventData = this.reportDatas.shift();
            if (!eventData) {
                continue;
            }
            // if (trimmedEventCount > LIMITATIONS.REPORT_BULK_ABORT_LIMIT) {
            //   /** Reach size limit in one process, discard datas beside limit size */
            //   this.reportDatas = [this.reportDatas[this.reportDatas.length - 1]];
            //   break;
            // }
            // if (
            //   entriesCount + eventData.events.length >
            //   LIMITATIONS.REPORT_BULK_TRIM_LIMIT
            // ) {
            //   trimmedEventCount++;
            //   // total datasize reach chunks limit, trim data and record aborted entries length
            //   // eventData.labels = Object.assign(eventData.labels ?? {}, {
            //   //   entries_length: eventData.data.exceptions.length,
            //   // });
            //   eventData.events = [eventData.events[0]];
            // }
            // // if (typeof eventData.labels?.entries_length === 'number') {
            // //   eventData.labels.entries_length = `${eventData.labels?.entries_length}`;
            // // }
            // entriesCount += eventData.events.length;
            chunks.push(eventData);
        }
        if (this.reportAtInterval) {
            this.processData();
        }
        return chunks;
    };
    ExceptionPlugin.prototype.sendData = function () {
        return __awaiter(this, void 0, void 0, function () {
            var chunks, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.reporter || !this.hasPendingData) {
                            return [2 /*return*/];
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 5, , 6]);
                        chunks = this.getDataChunks();
                        if (!chunks.length) {
                            return [2 /*return*/];
                        }
                        if (!(chunks.length === 1)) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.reporter.sendData(chunks[0])];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                    case 3: return [4 /*yield*/, this.reporter.sendBulkData(chunks)];
                    case 4:
                        _a.sent();
                        return [3 /*break*/, 6];
                    case 5:
                        error_1 = _a.sent();
                        log_1.Logger.error(error_1);
                        return [3 /*break*/, 6];
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    ExceptionPlugin.prototype.cacheData = function () {
        var _a, _b, _c;
        if (this.reportAtInterval && !((_b = (_a = this.reportDatas[0]) === null || _a === void 0 ? void 0 : _a.events) === null || _b === void 0 ? void 0 : _b.length)) {
            return;
        }
        (_c = this.reporter) === null || _c === void 0 ? void 0 : _c.offlineStore.cacheData(this.reportDatas);
        this.reportDatas = [];
    };
    Object.defineProperty(ExceptionPlugin.prototype, "hasPendingData", {
        get: function () {
            var _a;
            if (this.reportAtInterval) {
                var reportDatas = this.reportDatas.filter(function (data) { return data.events.length; });
                if (!reportDatas.length || !((_a = reportDatas[0]) === null || _a === void 0 ? void 0 : _a.events.length)) {
                    return false;
                }
                return true;
            }
            return this.reportDatas.length > 1;
        },
        enumerable: false,
        configurable: true
    });
    ExceptionPlugin.prototype.check = function () {
        try {
            if (!this.hasPendingData) {
                return;
            }
            if ('requestIdleCallback' in window) {
                requestIdleCallback(this.sendData.bind(this));
            }
            else {
                this.sendData();
            }
        }
        catch (error) {
            log_1.Logger.warn('[APMS] failed to process report datas.');
            log_1.Logger.error(error);
        }
    };
    ExceptionPlugin.prototype.start = function () {
        var _this = this;
        this.timer = setInterval(function () {
            _this.check();
        }, this.interval);
    };
    ExceptionPlugin.prototype.unregister = function () {
        if (this.appName) {
            delete ExceptionPlugin.TRIGGER_MAPS[this.appName];
        }
        if (this.timer) {
            clearInterval(this.timer);
        }
    };
    /* init listener & override onerror / unhandledrejection */
    ExceptionPlugin.prototype.init = function (de_app_id) {
        var _this = this;
        try {
            if (!this.reportAtInterval) {
                // report event when history changed - for crash rate calc
                var onHistoryChange = function (event) {
                    if (event === 'beforeunload') {
                        // 将现有记录存入本地缓存
                        _this.cacheData();
                    }
                    else {
                        // 添加新的页面记录
                        _this.processData();
                    }
                };
                var listener = new historyListner_1.HistoryListener();
                listener.add(de_app_id, onHistoryChange);
            }
            else {
                var terminationEvent = 'onpagehide' in self ? 'pagehide' : 'unload';
                window.addEventListener(terminationEvent, this.cacheData.bind(this), false);
            }
            this.start();
            if (ExceptionPlugin.filled) {
                return;
            }
            ExceptionPlugin.serverNow = this.serverNow.bind(this);
            this.trackGlobalError();
            this.trackUnhandledRejection();
            ExceptionPlugin.filled = true;
        }
        catch (error) {
            log_1.Logger.info('[APMS] Failed to init exception plugin');
            log_1.Logger.error(error);
        }
    };
    ExceptionPlugin.prototype.trackGlobalError = function () {
        var originalErrorHandler = window.onerror;
        window.onerror = function (event, source, lineno, colno, error) {
            // trigger
            ExceptionPlugin.trackError(event, error);
            if (typeof originalErrorHandler === 'function') {
                /* eslint-disable-next-line prefer-rest-params, @typescript-eslint/no-explicit-any */
                return originalErrorHandler.apply(this, arguments);
            }
            return false;
        };
    };
    ExceptionPlugin.prototype.trackUnhandledRejection = function () {
        var originalRejectionHanlder = window.onunhandledrejection;
        window.onunhandledrejection = function (evt) {
            ExceptionPlugin.trackEvent(evt);
            if (typeof originalRejectionHanlder === 'function') {
                /* eslint-disable-next-line prefer-rest-params, @typescript-eslint/no-explicit-any */
                return originalRejectionHanlder.apply(window, arguments);
            }
            return true;
        };
    };
    ExceptionPlugin.prototype.capture = function (data) {
        var _a, _b, _c;
        if (typeof this.triggerHandler !== 'function') {
            log_1.Logger.warn('[APMS] capture - triggerhandler not exist');
            return;
        }
        // 获取自定义上报数据
        var _d = data !== null && data !== void 0 ? data : {}, error = _d.error, message = _d.message, extraData = _d.data;
        if (!error && !message) {
            log_1.Logger.info('[APMS] error / message cannot be empty at the same time');
            return;
        }
        try {
            var stack = '';
            var errorMessage = message !== null && message !== void 0 ? message : '';
            var errorName = (_a = extraData === null || extraData === void 0 ? void 0 : extraData.name) !== null && _a !== void 0 ? _a : '';
            if ((0, utils_1.isErrorObject)(error)) {
                stack = error.stack;
                errorMessage = (_b = errorMessage + error.message) !== null && _b !== void 0 ? _b : '';
                errorName = (_c = errorName + error.name) !== null && _c !== void 0 ? _c : '';
            }
            else if (!errorMessage && typeof error === 'string') {
                errorMessage = error;
            }
            if (!stack) {
                // generate stack trace
                stack = new Error(errorMessage).stack;
            }
            var reportData = {
                // timestamp: this.serverNow(),
                js_error_type: 'custom',
                js_error_level: (extraData === null || extraData === void 0 ? void 0 : extraData.level) || 'error',
                js_error_name: errorName || 'error',
                js_error_message: errorMessage,
                js_error_stack: stack,
                js_original_exception: (0, utils_1.stringifyOriginalException)(error),
                js_data_field: (0, custom_1.transferDataField)(extraData === null || extraData === void 0 ? void 0 : extraData.data_field),
                js_extra: extraData === null || extraData === void 0 ? void 0 : extraData.extra,
                js_breadcrumbs: this.breadcrumb.get(),
                js_page_name: (extraData === null || extraData === void 0 ? void 0 : extraData.page_name) || window.location.hostname,
            };
            reportData.js_error_stack = (0, utils_1.preProcessStack)(reportData.js_error_stack);
            this.triggerHandler(reportData);
        }
        catch (error) {
            log_1.Logger.error(error);
        }
    };
    ExceptionPlugin.prototype.addBreadcrumb = function (breadcrumb) {
        this.breadcrumb.add(breadcrumb);
    };
    ExceptionPlugin.prototype.clearBreadcrumb = function () {
        this.breadcrumb.clear();
    };
    ExceptionPlugin.filled = false;
    ExceptionPlugin.TRIGGER_MAPS = {};
    return ExceptionPlugin;
}(apms_javascript_sdk_1.BasePlugin));
exports.default = ExceptionPlugin;
